import { useEffect, useState, useContext } from 'react';
import { NumericFormat } from 'react-number-format';

import { useGlobalStore } from '../contexts';

const GbitTableCell = ({ cellInfo, cellClick, cellChange }) => {
  const { store, updateStore } = useGlobalStore();

  const [originValue, setOriginValue] = useState(null);
  const [auto, setAuto] = useState(false);

  // const [cellValue, setCellValue] = useState(null);
  const [cellValue, setCellValue] = useState('');
  const [optionList, setOptionList] = useState([]);
  const [arrowClass, setArrowClass] = useState('');

  const getOptionList = () => {};

  useEffect(() => {
    setCellValue(cellInfo.value);

    if (
      cellInfo.option !== undefined &&
      cellInfo.option !== null &&
      cellInfo.option.length > 0
    ) {
      getOptionList();
    }
  }, [cellInfo]);

  useEffect(() => {
    setOriginValue(cellInfo.value);
  }, []);

  const clickEvt = () => {
    cellClick(cellInfo);
  };

  const checkChangeEvt = e => {
    cellChange(cellInfo, !cellValue);
    setCellValue(!cellValue);
  };

  const changeEvt = e => {
    setCellValue(e.target.value);
    cellChange(cellInfo, e.target.value);
  };

  const numberChangeEvt = e => {
    const returnValue = Number(e.target.value.replaceAll(',', ''));

    if (cellInfo.arrow !== undefined && cellInfo.arrow !== null) {
      if (cellInfo.arrow < returnValue) {
        setArrowClass(' input__increase');
      } else if (cellInfo.arrow > returnValue) {
        setArrowClass(' input__decrease');
      } else {
        setArrowClass('');
      }
    }

    setCellValue(returnValue);
    cellChange(cellInfo, returnValue);
  };

  const textSelectChangeEvt = (side, value) => {
    cellChange(cellInfo?.[side], value);
    setCellValue(cellValue?.[side], value);
  };

  const handleClick = () => {
    cellClick(cellInfo);
  };

  const handleChange = event => {
    cellChange(cellInfo, event.target.value);
  };

  return (
    <td onClick={handleClick}>
      {cellInfo.type === 'check' ? (
        <div className="form-check">
          <input
            type="checkbox"
            readOnly={cellInfo.readonly}
            id={cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo}
            name="selected"
            checked={cellValue}
            onChange={checkChangeEvt}
            aria-labelledby={
              cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo
            }
          />
          <label
            htmlFor={
              cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo
            }
          >
            <span className="sr-only">선택</span>
          </label>
        </div>
      ) : cellInfo.type === 'badge' ? (
        cellInfo.option === 'blue' ? (
          <button className="krds-badge bg1">{cellValue}</button>
        ) : cellInfo.option === 'white' ? (
          <button className="krds-badge outline">{cellValue}</button>
        ) : cellInfo.option === 'green' ? (
          <button className="krds-badge bg3">{cellValue}</button>
        ) : cellInfo.option === 'grey' ? (
          <button className="krds-badge bg2">{cellValue}</button>
        ) : cellInfo.value === '완료' ? (
          <button className="krds-badge bg3 pointer">{cellValue}</button>
        ) : cellInfo.value === '미진행' ? (
          <button className="krds-badge bg2 pointer">{cellValue}</button>
        ) : cellInfo.value === '진행중' ||
          cellInfo.value === '부가정보입력' ||
          cellInfo.value === '분석신청필요' ||
          cellInfo.value === '유효성분석진행중' ||
          cellInfo.value === '업로드필요' ? (
          <button className="krds-badge bg1 pointer">{cellValue}</button>
        ) : cellInfo.key === 'maxDanger' ? (
          cellInfo.value === 1 ? (
            // <span className="krds-badge bg5">매우낮음</span>
            <span className="krds-badge bg5">양호</span>
          ) : cellInfo.value === 2 ? (
            // <span className="krds-badge bg6">낮음</span>
            <span className="krds-badge bg6">모니터링</span>
          ) : cellInfo.value === 3 ? (
            // <span className="krds-badge bg7">중간</span>
            // <span className="krds-badge bg7">모니터링</span>
            <span className="krds-badge bg8">조사필요</span>
          ) : cellInfo.value === 4 ? (
            // <span className="krds-badge bg8">높음</span>
            <span className="krds-badge bg8">조사필요</span>
          ) : cellInfo.value === 5 ? (
            // <span className="krds-badge bg9">매우높음</span>
            <span className="krds-badge bg9">조사필요</span>
          ) : (
            <span className="">-</span>
          )
        ) : (
          <span className="krds-badge">{cellValue}</span>
        )
      ) : cellInfo.type === 'print' ? (
        <button className="btn sm" disabled={!cellValue}>
          인쇄
        </button>
      ) : cellInfo.type === 'link' ? (
        <a className="btn btn-txt md underline text-point-primary text-bold">
          {cellValue}
        </a>
      ) : cellInfo.type === 'inputText' ? (
        <input
          type="text"
          className="form-control sm"
          placeholder={cellInfo.placeholder}
          value={cellValue}
          readOnly={cellInfo.readonly}
          // onChange={handleChange}
          onChange={changeEvt}
          aria-labelledby={
            cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo
          }
          maxLength={cellInfo.maxLength}
          id={cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo}
        />
      ) : cellInfo.type === 'inputNumber' ? (
        <NumericFormat
          className="form-control sm"
          style={{
            textAlign: 'right',
          }}
          value={cellValue}
          placeholder={cellInfo.placeholder}
          readOnly={cellInfo.readonly}
          onChange={numberChangeEvt}
          thousandSeparator=","
        />
      ) : cellInfo.type === 'select' ? (
        optionList !== undefined &&
        optionList !== null &&
        optionList.length > 0 && (
          <select
            className="form-select sm"
            value={cellValue}
            onChange={changeEvt}
          >
            <option value="">선택</option>
            {optionList.map(item => {
              return (
                <option value={item.value} key={item.value}>
                  {item.name}
                </option>
              );
            })}
          </select>
        )
      ) : cellInfo.type === 'textSelect' ? (
        <div className="input-group">
          <input
            type="text"
            className="form-control sm"
            placeholder={cellInfo.placeholder}
            value={cellValue}
            readOnly={cellInfo.readonly}
            onChange={e => {
              textSelectChangeEvt('text', e.target.value);
            }}
            aria-labelledby={
              cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo
            }
            id={cellInfo.tableName + '_' + cellInfo.key + '_' + cellInfo.rowNo}
          />
          {optionList !== undefined &&
            optionList !== null &&
            optionList.length > 0 && (
              <select
                className="form-select sm"
                value={cellValue}
                onChange={e => {
                  textSelectChangeEvt('select', e.target.value);
                }}
              >
                <option value="">선택</option>
                {optionList.map(item => {
                  return (
                    <option value={item.value} key={item.value}>
                      {item.name}
                    </option>
                  );
                })}
              </select>
            )}
        </div>
      ) : cellInfo.type === 'text' ? (
        cellInfo.option === 'bold' ? (
          <strong>{cellValue}</strong>
        ) : (
          <span>{cellValue}</span>
        )
      ) : (
        <span>{cellValue}</span>
      )}
    </td>
  );
};

export default GbitTableCell;
